import React from "react";

const Services = ({ classicHeader, darkTheme }) => {
  // services details
  const services = [
    {
      name: "Výzkum a analýza trhu",
      desc: "Sbírám a analyzuji relevantní data a informace o cílové skupině, konkurenci a trendech na trhu.",
      icon: "fas fa-chart-simple",
    },
    {
      name: "Komunikační strategie",
      desc: "Připravím efektivní komunikační strategii, včetně reklamy, PR, digitálního marketingu a dalších kanálů komunikace.",
      icon: "fas fa-people-group",
    },
    {
      name: "Branding",
      desc: "Navrhnu a následně mohu pomoci při implementaci strategie, která přesně vymezí jasnou a autentickou identitu vaší značky.",
      icon: "fas fa-file-powerpoint",
    },
    {
      name: "Vytváření vizuální identity",
      desc: "Pomohu vám  vytvořit vizuální identitu značky, která zahrnuje logo, barvy, typografii a další vizuální prvky.",
      icon: "fas fa-palette",
    },
    {
      name: "Influencer manager",
      desc: "Zastupuji inflluencery při obchodních jednáních. Vyjednávání finančních podmínek, stanovení očekávání a cílů spolupráce.",
      icon: "fas fa-comment-dollar",
    },
    {
      name: "Strategie sociálních médií",
      desc: "Navrhnu strategii, která stanovuje cíle, cílovou skupinu, témata obsahu a plánování příspěvků na různých sociálních platformách.",
      icon: "fas fa-link",
    },
  ];

  return (
    <section
      id="services"
      className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-white-50  opacity-1" : "text-light  opacity-4")
            }
          >
            Služby
          </h2>
          <p
            className={
              "text-9  fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            Co dělám?
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        {/* content start */}
        <div className="row">
          <div className="col-lg-11 mx-auto">
            <div className="row">
              {services.length > 0 &&
                services.map((service, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="featured-box style-3 mb-5">
                      <div
                        className={
                          "featured-box-icon text-primary  shadow-sm rounded " +
                          (darkTheme ? "bg-dark-1" : "bg-white")
                        }
                      >
                        <i className={service.icon} />
                      </div>
                      <h3 className={darkTheme ? "text-white" : ""}>
                        {service.name}
                      </h3>
                      <p
                        className={"mb-0 " + (darkTheme ? "text-white-50" : "")}
                      >
                        {service.desc}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        {/* content end */}
      </div>
    </section>
  );
};

export default Services;
